import { useEffect, useState } from "react"

const getInitialOnlineStatus = (): boolean => {
    if (typeof window === "undefined" || typeof navigator === "undefined") {
        return true // SSR-safe default
    }
    return navigator.onLine
}

export const useOnlineStatus = () => {
    const [isOnline, setIsOnline] = useState(getInitialOnlineStatus)

    useEffect(() => {
        if (typeof window === "undefined") return

        const handleOnline = () => setIsOnline(true)
        const handleOffline = () => setIsOnline(false)

        window.addEventListener("online", handleOnline)
        window.addEventListener("offline", handleOffline)

        return () => {
            window.removeEventListener("online", handleOnline)
            window.removeEventListener("offline", handleOffline)
        }
    }, [])

    return { isOnline }
}
